import React, { lazy, Suspense, useEffect, useState } from "react";
import Header from "./components/Header";
import CallMeForm from "./components/CallMeForm";
import Body from "./components/Body";
import Footer from "./components/Footer";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import "@fontsource/poppins";
import axios from "axios";
import Navbar from "./components/Navbar";
import "./App.css";
import Contact from "./components/Contact";
import MediaQuery from "react-responsive";
import jsonData from "./components/ai-branding.json"; // Import the JSON file

function App() {
  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };
    fetchLinks();

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <>
    <CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
      {links ? (
        <>
          <Navbar />
          <MediaQuery minWidth={992}>
            <Suspense fallback={<div />}>
              <div className="blue-bg">
                <Header links={links.current}/>
              </div>
              <Contact />
            </Suspense>
          </MediaQuery>

          <MediaQuery maxWidth={991}>
            <Suspense fallback={<div />}>
              <div className="blue-bg">
                <Header links={links.current}/>
                <Contact />
              </div>
            </Suspense>
          </MediaQuery>

          <Body links={links.current} />
          <Footer />
        </>
      ) : (
        <div>Loading...</div>
      )}
      </CacheBuster>
    </>
  );
}

export default App;
